import {useMemo} from 'react';

import {useMarketingSplitCardsCarouselV1Query} from 'src/generated/graphql';

// Hook to load marketing split cards carousel data from GraphQL API
export const useMarketingSplitCardsData = () => {
    const {data, isLoading, error} = useMarketingSplitCardsCarouselV1Query();

    return useMemo(() => {
        const graphqlData = data?.marketingSplitCardsCarouselV1;
        const hasGraphqlData = graphqlData && graphqlData.cards && graphqlData.cards.length > 0;

        let header: {headline?: string; supportingText?: string | null} | null;
        let cards: Array<{title: string; url: string; image: {url: string}}>;

        if (hasGraphqlData) {
            // Use GraphQL marketing data
            header = graphqlData.header;
            cards = graphqlData.cards
                .filter((card): card is NonNullable<typeof card> => Boolean(card))
                .map((card) => ({
                    title: card.title,
                    url: card.url,
                    image: {url: card.image?.url || ''},
                }));
        } else {
            // No data available
            header = null;
            cards = [];
        }

        return {
            data: graphqlData,
            isLoading,
            error,
            header,
            cards,
            hasData: hasGraphqlData,
        };
    }, [data, isLoading, error]);
};
